module.exports = __webpack_public_path__ + "img/apply-to-all.40815d40.svg";